var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PartialView',[(_vm.hasAdmin('LOAN_TYPES'))?_c('LoanTypes',{ref:"loanTypes",staticClass:"admin-content-partial",attrs:{"header-tag":"h3","id":_vm.loanTypeId,"route-params":{view: 'types'},"show-back":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }